import {NgModule} from '@angular/core';
import {DexOnboardingFundingResolverService} from '../../components/dex/dex-onboarding-funding-resolver.service';
import {DexStreamingInitResolverService} from '../../components/dex/dex-streaming-init-resolver.service';
import {DexStreamingModule} from '../../components/dex/dex-streaming/dex-streaming.module';
import {FloatLayoutFactory} from '../../components/float-layout';
import {LayoutPresetSelectorModule} from '../../components/layout-preset-selector';
import {LayoutFactory} from '../../components/layout/layout.factory';
import {WidgetFactory} from '../../components/layout/widget/widget.factory';
import {TabFactory} from '../../components/tabs/tab.factory';
import {WatchlistModule} from '../../components/watchlist';
import {UrlHelperService} from '../../services/url-helper.service';
import {WidgetDetachService} from '../../services/widget-detach.service';
import {DashboardFactoryService} from './dashboard-factory.service';
import {UserDataResolverService} from './user-data-resolver.service';

@NgModule({
    imports: [
        LayoutPresetSelectorModule,
        WatchlistModule,
        DexStreamingModule
    ],
    providers: [
        LayoutFactory,
        WidgetFactory,
        UrlHelperService,
        FloatLayoutFactory,
        TabFactory,
        DashboardFactoryService,
        UserDataResolverService,
        WidgetDetachService,
        DexStreamingInitResolverService,

        // It's provided here for both Client and BO for simplicity, it checks existence of the API URL
        DexOnboardingFundingResolverService
    ],
    exports: [
        LayoutPresetSelectorModule
    ]
})
export class DashboardSharedModule {}
